import { SetPasswordForm } from "@/pages/auth/SetPasswordForm";
import { useTranslations } from "@/lib/useTranslations";

export function SetPasswordPage() {
  const t = useTranslations("setPassword");

  return (
    <main className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-6 py-16">
      <div className="wireframe-border space-y-6 bg-whart-bg p-8">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight text-whart-text">
            {t("title")}
          </h1>
          <p className="text-sm text-neutral-500">{t("subtitle")}</p>
        </div>

        <SetPasswordForm />
      </div>
    </main>
  );
}
